import React from "react";

import random from "lodash/random";

import { anim } from "./utils";
import { useAnimationsEnabled } from "../../lib/hooks/useQueryBoard";

const bump = (delay: number) => ({
  initial: { opacity: 0.75, scale: 0.35 },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 1,
      delay,
      type: "spring",
      stiffness: 400,
      damping: 20,
    },
  },
  tap: {
    scale: 0.95,
  },
  exit: {
    scale: 1,
  },
});

const Bump = (props: { children: React.ReactElement; disabled?: boolean }) => {
  const { children, disabled } = props;

  const animationsEnabled = useAnimationsEnabled();

  if (disabled || !animationsEnabled) {
    return children;
  }

  return React.cloneElement(children, { ...anim(bump(random(0.45, 0.65))) });
};

export default Bump;
